// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as LumiReactReducer from "lumi-rescript/lib/es6/src/LumiReactReducer.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as API$LumiAuthentication from "./API.res.js";
import * as Form$LumiAuthentication from "./Form.res.js";
import * as I18n$LumiAuthentication from "./I18n.res.js";
import * as Modal$LumiAuthentication from "./Modal.res.js";

function apiKeyFromUrl(url) {
  return new URLSearchParams(url.search).get("apiKey");
}

function APIKeyLogin$Error(props) {
  let dispatch = props.dispatch;
  return JsxRuntime.jsxs(Modal$LumiAuthentication.make, {
    title: "PhraseInvalidAPIKey",
    children: [
      JsxRuntime.jsx("section", {
        children: JsxRuntime.jsx(Form$LumiAuthentication.$$Error.make, {
          error: props.error
        }),
        className: "modal-card-body"
      }),
      JsxRuntime.jsx("footer", {
        children: JsxRuntime.jsxs("div", {
          children: [
            props.forceAPIKey ? null : JsxRuntime.jsx("p", {
                children: JsxRuntime.jsx("button", {
                  children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                    entry: "PhraseToLogin"
                  }),
                  className: "button",
                  type: "button",
                  onClick: param => dispatch("ToPasswordLogin")
                }),
                className: "control"
              }),
            JsxRuntime.jsx("p", {
              children: JsxRuntime.jsx("button", {
                children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                  entry: "PhraseRetry"
                }),
                className: "button is-success",
                type: "button",
                onClick: param => dispatch("Retry")
              }),
              className: "control"
            })
          ],
          className: "field is-grouped is-grouped-right is-flex-1"
        }),
        className: "modal-card-foot"
      })
    ]
  });
}

let $$Error = {
  make: APIKeyLogin$Error
};

function APIKeyLogin(props) {
  let toParent = props.toParent;
  let apiKey = props.apiKey;
  let tryPerformLogin = () => ({
    TAG: "InitWithEffect",
    _0: {
      lastError: undefined
    },
    _1: param => {
      let dispatch = param.dispatch;
      return LumiRequest.resultFutureEffect(API$LumiAuthentication.cookieLoginApiKey(apiKey), account => toParent({
        TAG: "Authenticated",
        _0: account
      }), err => dispatch({
        TAG: "APIKeyLoginFailed",
        _0: err
      }));
    }
  });
  let match = LumiReactReducer.useReducer(() => tryPerformLogin(), undefined, (_state, action) => {
    if (typeof action !== "object") {
      if (action === "ToPasswordLogin") {
        return {
          TAG: "Effect",
          _0: param => {
            toParent({
              TAG: "ShowPasswordLogin",
              initialEmail: "",
              initialError: undefined
            });
          }
        };
      } else {
        return LumiReactReducer.initToUpdate(tryPerformLogin());
      }
    }
    console.error("API key login failed", action._0);
    return {
      TAG: "Update",
      _0: {
        lastError: "PhraseInvalidAPIKey"
      }
    };
  });
  let lastError = match[0].lastError;
  if (lastError !== undefined) {
    return JsxRuntime.jsx(APIKeyLogin$Error, {
      error: lastError,
      forceAPIKey: props.forceAPIKey,
      dispatch: match[1]
    });
  } else {
    return null;
  }
}

let T;

let make = APIKeyLogin;

export {
  T,
  apiKeyFromUrl,
  $$Error,
  make,
}
/* LumiRequest Not a pure module */
